<template>
  <div class="sky-deploy-step-view-create-order-wrapper">
    <div class="wsp-margin-12 deploy-case">
      <div class="wsp-group-title">
        <div class="wsp-group-title-icon"></div>
        <div class="wsp-group-title-value">交付指导方案</div>
        <div class="wsp-group-title-tip"></div>
      </div>
      <div>
        <div class="order-download">
          <div>
            <div class="order-icon">
              <div :class="`wsp-icon-word wsp-icon wsp-icon-status-${buildStatus}`"></div>
              <div v-if="buildStatus === 'success'" class="order-status text">
                <sk-icon-status type="success" :content="`【${projectName} 】交付指导方案已生成`"></sk-icon-status>
              </div>
              <div v-else-if="buildStatus === 'pending'" class="order-status text">
                <sk-icon-status type="ing" content="交付指导方案生成中"></sk-icon-status>
              </div>
              <div v-else-if="buildStatus === 'error'" class="order-status text" @click="reGenerateDeliveryPlan">
                <sk-icon-status type="error" :content="`交付指导方案生成失败`"></sk-icon-status>
                <i class="el-icon-refresh icon-focus"></i>
              </div>
            </div>
            <div class="order-result text" style="font-weight: bolder;">
              交付指导方案可下载后根据需求做个性修订或可点击处理按钮随时在线调整方案内容
            </div>
            <div v-show="canDownload">
              <el-button type="success" @click="downloadDocument">下载Word</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wsp-margin-12">
      <div class="wsp-group-title">
        <div class="wsp-group-title-icon"></div>
        <div class="wsp-group-title-value">注意事项</div>
        <div class="wsp-group-title-tip"></div>
      </div>
      <div>
        <div>
          <el-table
            :border="true"
            :show-header="true"
            :data="deliveryGuideList"
            :column-drag-sortable="false"
            class="sky-host-dist"
            height="50vh"
          >
            <el-table-column label="序号" width="75" type="index" align="center" />
            <el-table-column label="注意事项" prop="docName" width="280" show-overflow-tooltip />
            <el-table-column label="分类" prop="guideSubType" width="280" show-overflow-tooltip />
            <el-table-column label="内容或链接" prop="guideDesc" show-overflow-tooltip />
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="showDetail(scope.row)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button, Table, TableColumn, Tag } from 'element-ui'

import { SkIconStatus } from 'sk-ui'

import { DELIVERY_PLAN_MNG } from '@/api/apiModules'
import { getDeliveryGuide } from '@/api/guide'
import { generateDeliveryPlan, getInstDeliveryPlan } from '@/api/plan'
import deliveryGuideDetail from '@/store/modules/deliveryGuideMng/metaData/deliveryGuideDetail'

require('vis-network/dist/dist/vis-network.min.css')

export default {
  name: 'StepViewCaseReport',
  components: {
    [Button.name]: Button,
    [Table.name]: Table,
    [Tag.name]: Tag,
    [TableColumn.name]: TableColumn,
    [SkIconStatus.name]: SkIconStatus
  },
  props: {
    data: {
      type: Object,
      default() {
        return null
      }
    }
  },
  mounted() {
    this.$emit('openChangeDialog', { projectId: this.data.projectId })
    this.$emit('showBtns', {
      preStep: true,
      nextStep: false,
      saveStep: false,
      enableTabChange: false,
      enableSkipNext: false
    })
    this.getInItData()
    this.buildInterval()
  },
  data: function() {
    return {
      projectName: '',
      buildStatus: 'pending',
      canDownload: false,
      deliveryGuideList: []
    }
  },
  methods: {
    showDetail(row) {
      const props = {
        params: {
          id: row.id
        }
      }
      this.$store.dispatch('OpenDrawerDetailRelation', {
        metaData: deliveryGuideDetail,
        props,
        drawerProps: {
          title: '详情',
          cbCloseDrawer: this.getData(),
          direction: 'rtl',
          class: 'wsp-case-relation-drawer-45'
        }
      })
    },
    getData() {
      return {}
    },
    buildInterval() {
      var cnt = 0
      this.buildStatus = 'pending'
      this.startTimer = setInterval(() => {
        cnt++
        if (cnt > 4) {
          this.canDownload = false
          this.buildStatus = 'error'
          clearInterval(this.startTimer)
          return
        }
        getInstDeliveryPlan({ id: this.data.projectId }).then(res => {
          if (res.data.content.instPlan.length > 0) {
            this.buildStatus = 'success'
            this.canDownload = true
            this.projectName = res?.data?.content?.projectName
            clearInterval(this.startTimer)
          }
        })
      }, 2500)
    },
    async gotoNextPreVliate() {
      return true
    },
    async gotoNextStep() {
      this.message = '点击了下一步'
      return true
    },
    gotoPreStep() {
      this.message = '点击了上一步'
      return true
    },
    getInItData() {
      this.buildStatus = 'pending'
      var req_paras = {
        id: this.data.projectId
      }
      generateDeliveryPlan(req_paras)
        .then(res => {})
        .catch(error => {
          this.buildStatus = 'error'
          this.canDownload = false
          clearInterval(this.startTimer)
        })
      getDeliveryGuide({ id: this.data.projectId })
        .then(res => {
          this.deliveryGuideList = res.data.content
        })
        .catch(error => {})
    },
    reGenerateDeliveryPlan() {
      this.buildInterval()
    },
    downloadDocument() {
      this.$store.dispatch('customDownloadDocument', {
        module: DELIVERY_PLAN_MNG,
        params: {
          id: this.data.projectId
        },
        action: 'downloadPlan'
      })
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(deploy-step-view-create-order-wrapper) {
  height: 78vh;
  .deploy-case {
    padding-top: 60px;
  }
  .order-download {
    display: flex;
    justify-content: center;
    text-align: center;
    .order-icon {
      display: flex;
      .wsp-icon-status-success {
        color: #3bb113;
      }
      .wsp-icon-status-pending {
        color: #e69d01;
      }
      .wsp-icon-status-error {
        color: #ec2805;
      }
      .wsp-icon {
        font-size: 28px;
        padding: 0 12px;
        text-align: right;
      }
      .order-status {
        line-height: 28px;
      }
    }
    .text {
      line-height: 28px;
    }
    .icon-focus {
      cursor: pointer;
    }
    .font-color {
      color: #ec2805;
    }
  }
}
</style>
